import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeftIcon, CheckIcon } from 'lucide-react';
import { REVIEWS } from '../data/site';
import { TrustScorePanel } from '../components/TrustScorePanel';
export function ReviewDetail() {
  const {
    slug
  } = useParams();
  const review = REVIEWS.find(r => r.slug === slug);
  if (!review) {
    return <div className="max-w-editorial mx-auto px-6 py-32 text-center" data-id="element-348">
        <h1 className="font-serif text-4xl tracking-tightest text-ink" style={{
        fontWeight: 500
      }} data-id="element-349">
          Review not found
        </h1>
        <Link to="/reviews" className="mt-6 inline-block text-trust-700 font-600" data-id="element-350">
          Back to all reviews
        </Link>
      </div>;
  }
  return <article className="max-w-editorial mx-auto px-6 py-16 md:py-24" data-id="element-351">
      <Link to="/reviews" className="inline-flex items-center gap-1.5 text-sm text-stone-500 hover:text-ink mb-8" data-id="element-352">
        <ArrowLeftIcon className="h-4 w-4" data-id="element-353" /> All reviews
      </Link>

      <p className="eyebrow text-trust-600 mb-4" data-id="element-354">{review.category} Review</p>
      <h1 className="font-serif tracking-tightest text-ink text-4xl md:text-6xl leading-[1.02] max-w-4xl" style={{
      fontWeight: 500
    }} data-id="element-355">
        {review.title}
      </h1>
      <p className="mt-5 text-lg text-stone-600" data-id="element-356">{review.product}</p>
      <p className="mt-2 text-sm text-stone-400" data-id="element-357">Updated {review.updated}</p>

      <div className="mt-12 grid lg:grid-cols-12 gap-12" data-id="element-358">
        <div className="lg:col-span-7" data-id="element-359">
          <div className="aspect-[16/10] overflow-hidden rounded-sm mb-8" data-id="element-360">
            <img src={review.image} alt={review.product} className="h-full w-full object-cover" data-id="element-361" />
          </div>
          <div className="prose-editorial space-y-5 text-stone-700 leading-relaxed text-[1.05rem]" data-id="element-362">
            <p data-id="element-363">{review.excerpt}</p>
            <p data-id="element-364">
              We evaluated this product against the Agreexa Trust Framework®,
              weighing measured performance against real-world reliability and
              the total cost of ownership over time. Rather than relying on
              manufacturer claims, our analysts verified specifications against
              independent testing and certified data.
            </p>
            <h2 className="font-serif text-2xl tracking-tightest text-ink pt-4" style={{
            fontWeight: 500
          }} data-id="element-365">
              What we liked
            </h2>
            <ul className="space-y-2 not-prose" data-id="element-366">
              {['Dependable, well-documented real-world performance', 'Transparent specifications that hold up to scrutiny', 'Strong long-term ownership economics'].map(item => <li key={item} className="flex items-start gap-2 text-stone-700" data-id="element-367">
                  <CheckIcon className="h-5 w-5 text-trust-600 shrink-0 mt-0.5" data-id="element-368" />
                  <span data-id="element-369">{item}</span>
                </li>)}
            </ul>
            <p data-id="element-370">
              Our full scoring rationale — including sources, testing process
              and affiliate disclosures — follows the standards published in the
              Agreexa Trust Framework.
            </p>
          </div>
        </div>

        <aside className="lg:col-span-5" data-id="element-371">
          <div className="lg:sticky lg:top-40" data-id="element-372">
            <TrustScorePanel review={review} data-id="element-373" />
          </div>
        </aside>
      </div>
    </article>;
}